<!-- 预约待反馈-反馈弹窗 -->
<template>
  <div class='modal-mask'
       v-if='isShow'
       @click="maskCloseBtn">
    <div class='modal-wrap'>
      <div class='modal-container'
           :style='{width: defaultWidth}'
           @click="closeContainerBtn">
        <h4 class='title'>Appointment information</h4>
        <p class='small-title'>{{appointInfo.module && new Map(packageModuleMap).get(appointInfo.module)}}</p>
        <div class='appoint-detail'>
          <div class='appoint-item'><span class='appoint-title'>Appointment start time：</span>{{appointInfo.mentorResultTimeStr}}（{{ appointInfo.menteeZone | timeZoneEnFilter }}）</div>
          <div class='appoint-item'><span>Expected duration：</span>{{appointInfo.predictTime}}mins</div>
          <div class='appoint-item'><span>Discussion topic：</span>{{appointInfo.title}}</div>
          <div class='appoint-item'><span>Other information：</span>{{appointInfo.otherMsg}}</div>
        </div>
        <div class='appoint-sub'>
          <div class='radio-wrap'>
            <h5 class='appoint-sub-title'>Please fill in the feedback：</h5>
            <div class='radio-group'>
              <Input type='textarea'
                     v-model='formValidate.details'
                     :rows='5'
                     placeholder="Please fill any necessary information in the feedback"
                     @on-change='changeFeedback' />
            </div>
            <p class='error'>{{feedbackError}}</p>
          </div>
          <div class='radio-wrap'>
            <span class='appoint-sub-title'>Please fill in the actual time you spent (mins)：</span>
            <span class='radio-group'>
              <InputNumber :min="1"
                           v-model="formValidate.timeSpent"
                           @on-change='changeTimes'></InputNumber>
            </span>
            <p class='error'>{{timesError}}</p>
          </div>
        </div>
        <div class='oper'>
          <Button @click="confirmCancel"
                  class='cancel'>Cancel</Button>
          <Button :loading='hasFeedback'
                  @click="confirmOk"
                  class='ok'>Confirm</Button>
        </div>
        <div class='modal-close'
             @click="maskCloseBtn">
          <img :src='modalClose' />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import modalClose from '@/assets/undergraduate/images/modal_close.png'
import appointmentService from '@/api/undergraduate/appointment'
import { packageModuleMap } from '../constants'
export default {
  name: '',
  props: {
    hasFeedback: {
      type: Boolean,
      default: false
    },
    feedbackId: {
      type: Number,
      default: -1
    },
    isShow: {
      type: Boolean,
      default: false
    },
    defaultWidth: {
      type: String,
      default: '500px'
    },
    maskClose: {
      type: Boolean,
      default: false
    }
  },
  components: {},
  data () {
    return {
      // 关闭图片
      modalClose,
      // 套餐模块映射
      packageModuleMap,
      // 预约详情
      appointInfo: {},
      // 反馈信息错误提示
      feedbackError: '',
      // 实际花费时间错误提示
      timesError: '',
      formValidate: {
        details: '',
        timeSpent: 1
      }
    }
  },
  computed: {},
  mounted () {
    this.getAppointDetail()
  },
  methods: {
    // 获取预约详情
    getAppointDetail () {
      if (this.feedbackId !== -1) {
        appointmentService.appointDetail({ id: this.feedbackId }).then(res => {
          this.appointInfo = res.data.model
        }).catch(res => {
          this.$ugd_message(res.message, 'error')
        })
      }
    },
    // 遮罩层点击关闭
    maskCloseBtn () {
      this.$emit('closeModal')
      this.resetStatus()
    },
    // 阻止冒泡
    closeContainerBtn (e) {
      e.stopPropagation()
      return false
    },
    // 确认弹窗的确认操作
    confirmOk () {
      if (this.isValid()) {
        let data = this.formValidate
        data.appointmentId = this.feedbackId
        this.$emit('feedbackModalOk', data)
      }
    },
    // 确认弹窗的取消操作
    confirmCancel () {
      this.maskCloseBtn()
    },
    // 反馈信息-change事件
    changeFeedback (e) {
      if (e.target.value === '') {
        this.feedbackError = 'Please fill in the feedback'
      } else {
        this.feedbackError = ''
        this.formValidate.details = e.target.value
      }
    },
    // 实际花费时间-change点击
    changeTimes (val) {
      if (!val) {
        this.timesError = 'Please fill in the actual time you spent'
      } else {
        this.timesError = ''
        this.formValidate.timeSpent = val
      }
    },
    // 重置状态
    resetStatus () {
      // 反馈信息错误提示
      this.feedbackError = ''
      // 实际花费时间错误提示
      this.timesError = ''
      this.formValidate = {
        details: '',
        timeSpent: 1
      }
    },
    // 提交前校验
    isValid () {
      let isOk = true
      if (this.formValidate.details === '') {
        this.feedbackError = 'Please fill in the feedback'
        isOk = false
      }
      if (!this.formValidate.timeSpent) {
        this.timesError = 'Please fill in the actual time you spent'
        isOk = false
      }
      return isOk
    }
  }
}
</script>
<style lang='less' scoped>
img {
  display: block;
  border: none;
}
.modal-mask {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(230, 234, 241, 0.7);
  z-index: 9999;
  .modal-wrap {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius: 8px;
    box-shadow: 0 8px 16px 0 #e6eaf1;
    .modal-container {
      background: #fff;
      padding: 60px;
      position: relative;
      .title {
        text-align: center;
        font-size: 20px;
        color: #6a7786;
        letter-spacing: 0;
      }
      .small-title {
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        color: #323c47;
        letter-spacing: 0;
        padding: 20px;
      }
      .appoint-detail {
        text-align: left;
        font-size: 16px;
        color: #667483;
        background: #f6f8fa;
        padding: 10px 20px;
        .appoint-item {
          span {
            color: #353f49;
            font-weight: bold;
          }
        }
      }
      .appoint-sub {
        text-align: left;
        font-size: 16px;
        .radio-wrap {
          padding-top: 20px;
          .appoint-sub-title {
            font-size: 16px;
            padding: 10px;
            color: #353f49;
            font-weight: bold;
            letter-spacing: 0;
            line-height: 22px;
            position: relative;
            &::after {
              content: "*";
              display: block;
              color: #ff5f00;
              position: absolute;
              top: 10px;
              left: 0;
            }
          }
          .radio-group {
            img {
              display: inline-block;
              width: 16px;
              height: 16px;
            }
            .text {
              margin-left: 20px;
            }
          }
        }
      }
      .oper {
        text-align: center;
        button {
          display: inline-block;
          font-size: 14px;
          margin: 20px;
          width: 116px;
          height: 32px;
          border-radius: 8px;
          text-align: center;
        }
        .cancel {
          border: 1px solid #b1bcc8;
          color: #b1bcc8;
        }
        .ok {
          background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
          color: #fff;
        }
      }
      .modal-close {
        position: absolute;
        right: 10px;
        top: 10px;
        width: 36px;
        height: 36px;
        padding: 10px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
  .error {
    color: #f00;
    font-size: 14px;
  }
}
</style>
